import { EnvironmentProviders, inject, provideEnvironmentInitializer, Provider } from '@angular/core';
import { MatDateFormats } from '@angular/material/core';
import { MAT_LUXON_DATE_ADAPTER_OPTIONS, provideLuxonDateAdapter } from '@angular/material-luxon-adapter';

import { LuxonService } from './luxon.service';

export function provideLuxon(): (Provider | EnvironmentProviders)[] {
  return [provideEnvironmentInitializer(() => inject(LuxonService))];
}

export function provideRmsLuxonDateAdapter(formats?: MatDateFormats): Provider[] {
  return [
    provideLuxonDateAdapter(formats),
    { provide: MAT_LUXON_DATE_ADAPTER_OPTIONS, useValue: { firstDayOfWeek: 1 } },
  ];
}
